import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';

export const Index = () => {
  return (
    <div className={styles.footerContainer}>
      <p>
        <span>完美世界（北京）软件科技发展有限公司 </span>
        <a
          style={{ color: 'rgba(255, 255, 255, 0.5)' }}
          href="https://beian.miit.gov.cn/" target="_blank">京ICP备15025398号-6</a>
      </p>
      <p>© 完美世界 版权所有 Perfect World. All Rights Reserved.</p>
    </div>
  );
};

export default Index;
